export function percentByPeriod(startedAt: Date | number, expiredAt: Date | number) {
  const start = new Date(startedAt).getTime();
  const end = new Date(expiredAt).getTime();
  const current = new Date().getTime();

  if (current <= start) return 0;
  if (current >= end) return 100;

  const totalDuration = end - start;
  const elapsed = current - start;

  return (elapsed / totalDuration) * 100;
}
